import { render } from "./createAssesment.vue?vue&type=template&id=cc1c236a&scoped=true"
import script from "./createAssesment?vue&type=script&lang=js"
export * from "./createAssesment?vue&type=script&lang=js"

import "./createAssesment.vue?vue&type=style&index=0&id=cc1c236a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc1c236a"]])

export default __exports__